import { route as checkoutRoute } from "@faire/web-api/routes/checkout";
import { getLocationOrThrow } from "@faire/web/common/globals/getLocation";
import { logError } from "@faire/web/common/logging";
import { makeObservable } from "@faire/web/common/makeObservable";
import { trackEvent } from "@faire/web/common/trackEvent";
import { MessengerStore } from "@faire/web/messenger/store/MessengerStore";
import { observable, reaction } from "mobx";
import { matchPath } from "react-router-dom";

import { UserStore } from "@faire/retailer/stores/domain/UserStore";

export class ChatBubbleGlobalUI {
  @observable
  private _isShowingChat: boolean = false;

  private isFirstPopUp = true;

  private closeCallback?: () => void;

  constructor(public messengerStore: MessengerStore) {
    makeObservable(this);
    const isOnCheckoutPage = () => {
      try {
        return !!matchPath(getLocationOrThrow().pathname, {
          path: checkoutRoute,
          exact: true,
        });
      } catch (err) {
        logError(err);
        return false;
      }
    };

    reaction(
      () => this.messengerStore.latestUnreadPopUpConversation,
      () => {
        if (
          this.isFirstPopUp &&
          !!this.messengerStore.latestUnreadPopUpConversation &&
          !isOnCheckoutPage()
        ) {
          this.isFirstPopUp = false;
          const userToken = UserStore.get().userToken;
          const otherPartyUserToken =
            this.messengerStore.latestUnreadPopUpConversation.otherPartyToken;
          const conversationToken =
            this.messengerStore.latestUnreadPopUpConversation.token;
          trackEvent(
            `/user/${userToken}/otherPartyUser/${otherPartyUserToken}/message/pop`
          );
          const brandToken =
            this.messengerStore.latestUnreadPopUpConversation.otherParty
              ?.brand_token;
          this.openChat({
            otherPartyUserToken,
            brandToken,
            conversationToken,
          });
        }
      }
    );
  }

  get isShowingChat(): boolean {
    return this._isShowingChat;
  }

  openChat = (
    params?: {
      brandToken?: string;
      retailerToken?: string;
      otherPartyUserToken?: string;
      conversationToken?: string;
    },
    closeCallback?: () => void
  ) => {
    this._isShowingChat = true;
    this.closeCallback = closeCallback;
    return this.messengerStore.setCurrentConversation(params);
  };

  closeChat = () => {
    this._isShowingChat = false;
    if (this.closeCallback) {
      this.closeCallback();
      this.closeCallback = undefined;
    }
  };
}
